/**
 * Management → Team Credit Report。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_team_credit_report。
 *
 * 正在用：
 * - Soft / Hard tab 各连一个团队账号
 * - 新建：Connect new account → 弹窗 Connect
 * - 改账号：Edit → 同一弹窗 Connect，记 UPDATE
 * - Remove
 * - Soft tab：Allow borrower to initiate soft credit pull
 * - Soft / Hard tab 切换
 *
 * 已不算：Cancel、个人 Credit report、Set as default。
 */
export enum MgmtTeamCreditReportEvent {
    /**
     * 切换 Soft / Hard tab。
     * value 与 metadata.tab 相同：soft_pull|hard_pull
     */
    TAB = 'TEAM_CREDIT_REPORT_TAB',
    /**
     * Connect new account：弹窗点 Connect 落库。
     * 属性 type=soft_pull|hard_pull
     */
    CONNECT_NEW_ACCOUNT = 'TEAM_CREDIT_REPORT_CONNECT_NEW_ACCOUNT',
    /**
     * Edit 后弹窗点 Connect。
     * 属性 type=soft_pull|hard_pull
     */
    UPDATE = 'TEAM_CREDIT_REPORT_UPDATE',
    /**
     * 删除账号。
     * 属性 type=soft_pull|hard_pull
     */
    REMOVE = 'TEAM_CREDIT_REPORT_REMOVE',
    /**
     * Allow borrower to initiate soft credit pull。
     * 属性 enabled=true|false
     */
    ALLOW_SOFT_PULL_SWITCH = 'TEAM_CREDIT_REPORT_ALLOW_SOFT_PULL_SWITCH',
}
